// import React, { useEffect, useState } from "react";
// import supabase from "../../supabaseClient";

// export default function ComplianceCMS() {
//   const [reportDate, setReportDate] = useState("");
//   const [monthlyData, setMonthlyData] = useState([]);
//   const [annualData, setAnnualData] = useState([]);

//   // Fetch from DB
//   async function fetchData() {
//     const { data: report } = await supabase
//       .from("compliance_report")
//       .select("*")
//       .single();
//     if (report) setReportDate(report.report_date);

//     const { data: monthly } = await supabase
//       .from("compliance_monthly")
//       .select("*")
//       .order("id", { ascending: true });
//     setMonthlyData(monthly || []);

//     const { data: annual } = await supabase
//       .from("compliance_annual")
//       .select("*")
//       .order("id", { ascending: true });
//     setAnnualData(annual || []);
//   }

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // Update Report Date
//   async function updateReportDate() {
//     await supabase.from("compliance_report").upsert([
//       { id: 1, report_date: reportDate },
//     ]);
//     fetchData();
//   }

//   // Monthly CRUD
//   async function addMonthly() {
//     await supabase
//       .from("compliance_monthly")
//       .insert([{ month_label: "January 2026", carried: 0, received: 0, resolved: 0, pending: 0 }]);
//     fetchData();
//   }

//   async function updateMonthly(idx, key, value) {
//     const row = monthlyData[idx];
//     row[key] = value;
//     await supabase.from("compliance_monthly").update(row).eq("id", row.id);
//     fetchData();
//   }

//   async function deleteMonthly(id) {
//     await supabase.from("compliance_monthly").delete().eq("id", id);
//     fetchData();
//   }

//   // Annual CRUD
//   async function addAnnual() {
//     await supabase
//       .from("compliance_annual")
//       .insert([{ year_label: "2025-26", carried: 0, received: 0, resolved: 0, pending: 0 }]);
//     fetchData();
//   }

//   async function updateAnnual(idx, key, value) {
//     const row = annualData[idx];
//     row[key] = value;
//     await supabase.from("compliance_annual").update(row).eq("id", row.id);
//     fetchData();
//   }

//   async function deleteAnnual(id) {
//     await supabase.from("compliance_annual").delete().eq("id", id);
//     fetchData();
//   }

//   return (
//     <div className="p-6 space-y-6">
//       {/* Report Date */}
//       <div className="p-4 bg-white rounded shadow">
//         <h2 className="font-semibold mb-2">Report Date</h2>
//         <input
//           type="date"
//           value={reportDate || ""}
//           onChange={(e) => setReportDate(e.target.value)}
//           className="border p-2 rounded"
//         />
//         <button onClick={updateReportDate} className="ml-3 px-4 py-2 bg-green-600 text-white rounded">
//           Update
//         </button>
//       </div>

//       {/* Monthly */}
//       <div className="p-4 bg-white rounded shadow">
//         <div className="flex justify-between">
//           <h2 className="font-semibold">Monthly Complaints</h2>
//           <button onClick={addMonthly} className="bg-blue-600 text-white px-3 py-1 rounded">
//             + Add Month
//           </button>
//         </div>
//         <table className="w-full mt-3 border text-sm">
//           <thead className="bg-slate-100">
//             <tr>
//               <th className="p-2 border">Month</th>
//               <th className="p-2 border">Carried</th>
//               <th className="p-2 border">Received</th>
//               <th className="p-2 border">Resolved</th>
//               <th className="p-2 border">Pending</th>
//               <th className="p-2 border">Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {monthlyData.map((m, idx) => (
//               <tr key={m.id}>
//                 {["month_label", "carried", "received", "resolved", "pending"].map((key) => (
//                   <td className="border p-1" key={key}>
//                     <input
//                       className="w-full p-1"
//                       value={m[key]}
//                       onChange={(e) => updateMonthly(idx, key, e.target.value)}
//                     />
//                   </td>
//                 ))}
//                 <td className="border p-1">
//                   <button className="bg-red-500 text-white px-2 rounded" onClick={() => deleteMonthly(m.id)}>
//                     X
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Annual */}
//       <div className="p-4 bg-white rounded shadow">
//         <div className="flex justify-between">
//           <h2 className="font-semibold">Annual Complaints</h2>
//           <button onClick={addAnnual} className="bg-purple-600 text-white px-3 py-1 rounded">
//             + Add Year
//           </button>
//         </div>
//         <table className="w-full mt-3 border text-sm">
//           <thead className="bg-slate-100">
//             <tr>
//               <th className="p-2 border">Year</th>
//               <th className="p-2 border">Carried</th>
//               <th className="p-2 border">Received</th>
//               <th className="p-2 border">Resolved</th>
//               <th className="p-2 border">Pending</th>
//               <th className="p-2 border">Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {annualData.map((a, idx) => (
//               <tr key={a.id}>
//                 {["year_label", "carried", "received", "resolved", "pending"].map((key) => (
//                   <td className="border p-1" key={key}>
//                     <input
//                       className="w-full p-1"
//                       value={a[key]}
//                       onChange={(e) => updateAnnual(idx, key, e.target.value)}
//                     />
//                   </td>
//                 ))}
//                 <td className="border p-1">
//                   <button className="bg-red-500 text-white px-2 rounded" onClick={() => deleteAnnual(a.id)}>
//                     X
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import supabase from "../../supabaseClient";

export default function ComplianceCMS() {
  const [reportDate, setReportDate] = useState("");
  const [monthlyData, setMonthlyData] = useState([]);
  const [annualData, setAnnualData] = useState([]);
  const [channelsData, setChannelsData] = useState([]);

  // Fetch data from all tables
  async function fetchData() {
    const { data: report } = await supabase
      .from("compliance_report")
      .select("*")
      .single();
    if (report?.report_date) {
      setReportDate(new Date(report.report_date).toISOString().split("T")[0]);
    }

    const { data: monthly } = await supabase
      .from("compliance_monthly")
      .select("*")
      .order("id", { ascending: true });
    setMonthlyData(monthly || []);

    const { data: annual } = await supabase
      .from("compliance_annual")
      .select("*")
      .order("id", { ascending: true });
    setAnnualData(annual || []);

    const { data: channels } = await supabase
      .from("compliance_channels")
      .select("*")
      .order("id", { ascending: true });
    setChannelsData(channels || []);
  }

  useEffect(() => {
    fetchData();
  }, []);

  // Update Report Date
  async function updateReportDate() {
    if (!reportDate) return;

    const formattedDate = new Date(reportDate).toISOString().split("T")[0];

    await supabase
      .from("compliance_report")
      .update({ report_date: formattedDate })
      .eq("id", 1);

    fetchData();
  }

  // Monthly Update
  async function updateMonthly(idx, key, value) {
    const row = { ...monthlyData[idx], [key]: value };
    await supabase.from("compliance_monthly").update(row).eq("id", row.id);
    fetchData();
  }

  async function addMonthly() {
    await supabase.from("compliance_monthly").insert([
      {
        month_label: "January 2026",
        carried: 0,
        received: 0,
        resolved: 0,
        pending: 0,
      },
    ]);
    fetchData();
  }

  async function deleteMonthly(id) {
    await supabase.from("compliance_monthly").delete().eq("id", id);
    fetchData();
  }

  // Annual Update
  async function updateAnnual(idx, key, value) {
    const row = { ...annualData[idx], [key]: value };
    await supabase.from("compliance_annual").update(row).eq("id", row.id);
    fetchData();
  }

  async function addAnnual() {
    await supabase.from("compliance_annual").insert([
      {
        year_label: "2025-26",
        carried: 0,
        received: 0,
        resolved: 0,
        pending: 0,
      },
    ]);
    fetchData();
  }

  async function deleteAnnual(id) {
    await supabase.from("compliance_annual").delete().eq("id", id);
    fetchData();
  }

  // Channels Update (Edit only — NO delete)
  async function updateChannel(idx, key, value) {
    const row = { ...channelsData[idx], [key]: value };
    await supabase.from("compliance_channels").update(row).eq("id", row.id);
    fetchData();
  }

  return (
    <div className="p-6 space-y-6">
      {/* Report Date */}
      <div className="p-4 bg-white rounded shadow">
        <h2 className="font-semibold mb-2">Report Date</h2>
        <input
          type="date"
          value={reportDate || ""}
          onChange={(e) => setReportDate(e.target.value)}
          className="border p-2 rounded"
        />
        <button
          onClick={updateReportDate}
          className="ml-3 px-4 py-2 bg-green-600 text-white rounded"
        >
          Update
        </button>
      </div>

      {/* Channels Section */}
      <div className="p-4 bg-white rounded shadow">
        <h2 className="font-semibold">Complaint Channels</h2>
        <table className="w-full mt-3 border text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="p-2 border">Channel</th>
              <th className="p-2 border text-center">Pending Last Month</th>
              <th className="p-2 border text-center">Received</th>
              <th className="p-2 border text-center">Resolved*</th>
              <th className="p-2 border text-center">Total Pending</th>
              <th className="p-2 border text-center">Pending &gt; 3 Months</th>
              <th className="p-2 border text-center">Avg Days</th>
            </tr>
          </thead>
          <tbody>
            {channelsData.map((c, idx) => (
              <tr key={c.id}>
                <td className="border p-1">{c.channel}</td>
                {[
                  "pending_last_month",
                  "received",
                  "resolved",
                  "pending",
                  "pending_over_3_months",
                  "avg_days",
                ].map((key) => (
                  <td className="border p-1" key={key}>
                    <input
                      className="w-full p-1 text-center"
                      value={c[key]}
                      onChange={(e) => updateChannel(idx, key, e.target.value)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Monthly */}
      <div className="p-4 bg-white rounded shadow">
        <div className="flex justify-between">
          <h2 className="font-semibold">Monthly Complaints</h2>
          <button
            onClick={addMonthly}
            className="bg-blue-600 text-white px-3 py-1 rounded"
          >
            + Add Month
          </button>
        </div>
        <table className="w-full mt-3 border text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="p-2 border">Month</th>
              <th className="p-2 border">Carried</th>
              <th className="p-2 border">Received</th>
              <th className="p-2 border">Resolved</th>
              <th className="p-2 border">Pending</th>
              <th className="p-2 border">Action</th>
            </tr>
          </thead>
          <tbody>
            {monthlyData.map((m, idx) => (
              <tr key={m.id}>
                {[
                  "month_label",
                  "carried",
                  "received",
                  "resolved",
                  "pending",
                ].map((key) => (
                  <td className="border p-1" key={key}>
                    <input
                      className="w-full p-1"
                      value={m[key]}
                      onChange={(e) => updateMonthly(idx, key, e.target.value)}
                    />
                  </td>
                ))}
                <td className="border p-1">
                  <button
                    className="bg-red-500 text-white px-2 rounded"
                    onClick={() => deleteMonthly(m.id)}
                  >
                    X
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Annual */}
      <div className="p-4 bg-white rounded shadow">
        <div className="flex justify-between">
          <h2 className="font-semibold">Annual Complaints</h2>
          <button
            onClick={addAnnual}
            className="bg-purple-600 text-white px-3 py-1 rounded"
          >
            + Add Year
          </button>
        </div>
        <table className="w-full mt-3 border text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="p-2 border">Year</th>
              <th className="p-2 border">Carried</th>
              <th className="p-2 border">Received</th>
              <th className="p-2 border">Resolved</th>
              <th className="p-2 border">Pending</th>
              <th className="p-2 border">Action</th>
            </tr>
          </thead>
          <tbody>
            {annualData.map((a, idx) => (
              <tr key={a.id}>
                {[
                  "year_label",
                  "carried",
                  "received",
                  "resolved",
                  "pending",
                ].map((key) => (
                  <td className="border p-1" key={key}>
                    <input
                      className="w-full p-1"
                      value={a[key]}
                      onChange={(e) => updateAnnual(idx, key, e.target.value)}
                    />
                  </td>
                ))}
                <td className="border p-1">
                  <button
                    className="bg-red-500 text-white px-2 rounded"
                    onClick={() => deleteAnnual(a.id)}
                  >
                    X
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
